import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import LanguageContext from "components/LanguageContext";
import Wrapper from "components/LayoutFront/Wrapper";
import SiteContext from "components/SiteContext";
import home from "components/templates/home/home";
import homeDsfr from "components/templates/homeDsfr/homeDsfr";
import homeMairie from "components/templates/homeMairie/homeMairie";
import homeProcessSites from "components/templates/homeProcessSites/homeProcessSites";
import Block from "components/templatesComponents/Block";
import Button from "components/templatesComponents/Button";
import Link from "components/templatesComponents/Link";
import Pictogram from "components/templatesComponents/Pictogram";
import { useFindPagesByTemplateKeys } from "hooks/page.hook";
import React, { useContext } from "react";
import Helmet from "react-helmet";
import t from "utils/locales/translation.json";

const NotFound = () => {
  const { language } = useContext(LanguageContext);
  const site = useContext(SiteContext);
  const { name: siteName } = site || {};

  const { data } = useFindPagesByTemplateKeys({
    templates: [home.key, homeProcessSites.key, homeDsfr.key, homeMairie.key],
    filters: [`page.lang||eq||${language}`],
    sort: ["updated,DESC"],
  });

  const { pages = [] } = data || {};

  const homePage =
    pages &&
    pages.find((version) => [home.key, homeProcessSites.key, homeMairie.key, homeDsfr.key].includes(version.template));

  return (
    <Wrapper wrapperProps={{ sx: { position: "relative" } }}>
      <Helmet>
        <title>
          {t[language].not_found.balise_title}
          {siteName === "ANTS" ? "" : " - "}
          {t[language].site_name[siteName]} - France Titres (ANTS)
        </title>
      </Helmet>
      <Block>
        <Grid
          container
          sx={{
            alignItems: "center",
            justifyContent: { xs: "center", md: "space-between" },
          }}
          spacing={{ xs: 5, md: 0 }}
        >
          <Grid size={{ xs: 12, md: 7 }}>
            <Stack>
              <h1>{t[language].not_found.balise_title}</h1>
              <Box component="p" className="fr-text--sm" sx={{ color: "var(--text-mention-grey)" }}>
                {t[language].not_found.error}
              </Box>
              <p className="fr-text--xl">{t[language].not_found.subtitle}</p>
              <p className="fr-text--sm">
                {t[language].not_found.message1}
                <br />
                {t[language].not_found.message2}
              </p>
              <Button
                basic
                component={Link}
                page={homePage}
                sx={{ mt: 2, justifyContent: "center", width: { xs: "100%", md: "fit-content" } }}
              >
                {t[language].not_found.button_title}
              </Button>
            </Stack>
          </Grid>
          <Grid size={{ xs: "grow", sm: 6, md: 3 }}>
            <Pictogram folder="system" pictogram="technical-error" withBackground />
          </Grid>
        </Grid>
      </Block>
    </Wrapper>
  );
};

export default NotFound;
